import { render, staticRenderFns } from "./StatementLayout.vue?vue&type=template&id=3345e5e8&scoped=true"
import script from "./StatementLayout.vue?vue&type=script&lang=js"
export * from "./StatementLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3345e5e8",
  null
  
)

export default component.exports